<template>
  <!--
          作者：gmshop
          时间：2019-10-25
          描述：团队列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="团队名称"><el-input v-model="formInline.unit_group_name" placeholder="团队名称" style="width:120px"></el-input></el-form-item>


        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>

      </el-form>
    </div>
    <!--添加团队-->
    <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/unit/group/add'">添加团队</el-button></div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="unit_group_id" label="团队ID" width="60"></el-table-column>

          <el-table-column prop="unit_group_name" label="团队名称"></el-table-column>
          <el-table-column prop="groupUser.real_name" label="队长名称"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" ></el-table-column>
          <el-table-column fixed="right" label="操作" >
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/unit/group/edit'">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/unit/group/delete'">删除</el-button>
              <el-button @click="userListClick(scope.row)" type="text" size="small" v-auth="'/unit/group/userlist'">成员列表</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <div class="common-button-wrapper">
      <el-button size="small" type="info" @click="cancelFunc">返回</el-button>

    </div>
  </div>
</template>

<script>
import unitApi from '@/api/unit.js';
import qs from 'qs';

export default {
  components: {

  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        unit_group_name: '',

      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      unit_id:'',
    };
  },
  created() {
     this.unit_id =this.$route.query.unit_id;
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      self.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.unit_id = this.unit_id;
      unitApi.groupList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick() {
      let self = this;
      let params = self.unit_id;
      this.$router.push({
        path: '/unit/group/add',
        // name: 'mallList',
        query: {
          unit_id: params
        }
      });
      //this.$router.push('/unit/group/add');
    },

    /*打开编辑*/
    editClick(row) {
      let self = this;
      let params = row.unit_group_id;
      this.$router.push({
        path: '/unit/group/edit',
        // name: 'mallList',
        query: {
          unit_group_id: params,
          unit_id:self.unit_id
        }
      });
    },
    userListClick(row) {
      let self = this;
      let params = row.unit_group_id;
      this.$router.push({
        path: '/unit/group/userlist',
        // name: 'mallList',
        query: {
          unit_group_id: params,
          unit_id:self.unit_id
        }
      });
    },
    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          unitApi.deleteGroup(
            {
              unit_group_id: row.unit_group_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: '恭喜你，团队删除成功',
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    /*批量导入团队*/
    openUpload() {
      this.open_add = true;
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/unit/group/index.vue